/**
 * 공정 노드용 아이콘 — 공장(생산)·상자(키팅)·트럭(운송) 세 종류.
 *
 * MUI 아이콘을 쓰지 않는다 — 노드 상자 안에 14px 안팎으로 앉혀야 해서 뷰박스·자리맞춤을
 * 직접 쥐고 있는 편이 낫고, <svg> 하나(FloSvg)에 <g> 로 얹을 뿐이라 별도 아이콘
 * 패키지를 새로 끌어올 이유가 없다. 24x24 뷰박스에 단순한 윤곽만 둔다.
 *
 * 중립 leaf — pages/** 를 import 하지 않는다.
 */

/** 공장(생산) — 계단 지붕 실루엣 + 작은 창 세 개. */
function FactoryPath() {
  return (
    <>
      <path d="M3 21V9l5 3V9l5 3V9l5 3V4h2v17H3z" />
      <rect x="5.5" y="14.5" width="1.6" height="1.6" fill="#fff" />
      <rect x="10.5" y="14.5" width="1.6" height="1.6" fill="#fff" />
      <rect x="15.5" y="14.5" width="1.6" height="1.6" fill="#fff" />
    </>
  );
}

/** 상자(키팅) — 조립 꾸러미를 나타내는 육각 큐브 윤곽. */
function BoxPath() {
  return (
    <path
      d="M12 2.4 3.8 7v10L12 21.6 20.2 17V7z M3.8 7 12 11.6 20.2 7 M12 11.6V21.6"
      fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round"
    />
  );
}

/** 트럭(운송) — 캡+적재함 실루엣과 바퀴 두 개. */
function TruckPath() {
  return (
    <>
      <path d="M2 6.5h11.5v9H2z" />
      <path d="M13.5 10h4l3.2 3v2.5h-7.2z" />
      <circle cx="6.2" cy="17.3" r="1.7" fill="#fff" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="17" cy="17.3" r="1.7" fill="#fff" stroke="currentColor" strokeWidth="1.3" />
    </>
  );
}

const ICONS = { make: FactoryPath, kit: BoxPath, move: TruckPath };

/**
 * 공정 종류 아이콘. x·y 는 아이콘 왼쪽 위(뷰박스 24 기준 size 로 축소해 배치)다.
 */
export default function ProcIcon({ kind, x, y, size = 14, color }) {
  const Glyph = ICONS[kind] || FactoryPath;
  const scale = size / 24;
  return (
    <g transform={`translate(${x} ${y}) scale(${scale})`} fill={color} stroke="none">
      <Glyph />
    </g>
  );
}
